<template>
  <CloudModal
    :value="visible"
    :scrollable="true"
    :title="title || i18n.t('title123')"
    @on-cancel="cancel('form')"
    class="verify-home"
    class-name="vertical-center-modal"
    :mask-closable="false"
  >
    <div :class="'proxy-text-home ' + className" :id="className">
      <CloudForm
        label-position="left"
        :model="form"
        ref="form"
        class="verify-body"
        :label-width="stateLang ? 75 : 50"
        :rules="proxyRules"
        @submit.native.prevent
      >
        <CloudFormItem v-if="showEmpId" prop="emp_id">
          <!--请输入工号-->
          <CloudInput
            type="text"
            ref="sitePwdInput"
            v-model="form.emp_id"
            placeholder="请输入工号"
          ></CloudInput>
        </CloudFormItem>
        <!-- 密码 -->
        <CloudFormItem
          :prop="passwordType"
          class="password-wrapper-item"
          v-if="type === 'password'"
        >
          <!--密码-->
          <CloudInput
            :type="passwordType"
            elementId="password"
            @keyup.enter.native="submit('form')"
            ref="sitePwdInput"
            v-model="form.password"
            :placeholder="i18n.t('placeholder177')"
          >
            <LutticaIcon type="iconlock" size="24" slot="prepend"></LutticaIcon>
            <div
              @mouseup="switchPasswordType('password')"
              class="show-password"
              slot="append"
              style="cursor: pointer"
              v-show="form.password && type === 'password'"
              @mousedown="switchPasswordType('text')"
            >
              <LutticaIcon :type="iconType" size="22" slot="prepend"></LutticaIcon>
            </div>
          </CloudInput>
        </CloudFormItem>
        <template v-if="passwordType === 'textarea'">
          <CloudFormItem prop="passwordType">
            <CloudInput
              type="textarea"
              ref="sitePwdInput"
              :maxlength="100"
              v-model="form.password"
              :placeholder="i18n.t('placeholder705')"
            ></CloudInput>
          </CloudFormItem>
          <!--附件-->
          <CloudFormItem class="plul-load-item" :label="i18n.t('table36')">
            <PlupLoad
              :list.sync="attachments"
              :clear="clearFileList"
              ref="plupLoad"
              @on-upload="submit('form')"
            />
          </CloudFormItem>
        </template>
      </CloudForm>
      <template v-if="type !== 'textarea'">
        <!--二维码-->
        <div v-show="type === 'qrcode'" id="qrcode-img" class="qrcode-img" align="center">
          <div id="qrcode-wage" />
        </div>
      </template>
    </div>
    <div slot="footer" class="footer-box" :class="{ 'qrcode-box': type !== 'textarea' }">
      <div v-if="type !== 'textarea'" class="code-login">
        <template v-for="item in tpCodeList">
          <div v-if="thirdParty[item.type]" :key="item.type">
            <CloudButton
              class="third-party"
              type="text"
              :title="thirdParty[item.type].title"
              @click="thirdPartyCode(item)"
            >
              <LutticaIcon :type="thirdParty[item.type].icon" size="25"></LutticaIcon>
            </CloudButton>
          </div>
        </template>
      </div>
      <CloudButton
        class="submit"
        v-show="submitShow"
        type="primary"
        @click="plupLoadSubmit('form')"
        shape="circle"
        :loading="loading"
      >
        {{ i18n.t('button03') }}
      </CloudButton>
    </div>
  </CloudModal>
</template>

<script>
import wxLogin from '@/utils/vendor/wxLogin';
import WwLogin from '@/utils/vendor/wwLogin-1.2.7';
import ddLogin from '@/utils/vendor/ddLogin';
import fsLogin from '@/utils/vendor/LarkSSOSDKWebQRCode-1.0.2';
import i18n from '@/i18n/i18n';
import user from '@/api/user/user';
import PlupLoad from '@/components/BusinessComponent/PlupLoad/Plupload.vue';
import store from '@/store/index';

export default {
  name: 'VerifyPassword',
  props: {
    visible: Boolean,
    type: {
      type: String,
      default: 'password',
    },
    onOk: Function,
    onCancel: Function,
    className: String,
    content: {
      type: [String, Boolean],
      default: false,
    },
    showEmpId: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
  },
  components: {
    PlupLoad,
  },
  data() {
    return {
      loading: false,
      passwordType: this.type,
      attachments: [],
      clearFileList: {},
      form: {},
      resolve: '',
      reject: '',
      promise: '', // 保存promise对象
      iconType: 'iconyanjing',
      proxyRulesNone: {},
      i18n,
      submitShow: true,
      qrCode: null,
      tpCodeList: [],
      thirdParty: {
        wechat: {
          icon: 'iconweixin',
          title: i18n.t('title249'),
        },
        weixin: {
          icon: 'iconqiyeweixin',
          title: i18n.t('title246'),
        },
        dingding: {
          icon: 'icondingding',
          title: i18n.t('title247'),
        },
        feishu: {
          icon: 'iconfeishu1',
          title: i18n.t('title248'),
        },
        password: {
          icon: 'iconlock',
          title: i18n.t('title123'),
        },
      },
    };
  },
  computed: {
    proxyRules() {
      return {
        password: [
          {
            required: true,
            message: i18n.t('placeholder177'),
            trigger: 'blur',
          },
        ],
        emp_id: [
          {
            required: true,
            message: '请输入工号',
            trigger: 'blur',
          },
        ],
      };
    },
    stateLang() {
      return localStorage.getItem('lang') === 'en';
    },
  },
  watch: {
    type(val) {
      if (val) {
        this.passwordType = val;
      }
    },
  },
  mounted() {
    if (this.type !== 'textarea') {
      this.queryTpcode();
    }
  },
  methods: {
    thirdPartyCode(item) {
      this.qrCode = item;
      if (item.type === 'password') {
        this.type = 'password';
        this.submitShow = true;
      } else {
        this.type = 'qrcode';
        this.submitShow = false;
        switch (item.type) {
          case 'wechat':
            this.wxLogin();
            break;
          case 'weixin':
            this.wwLogin();
            break;
          case 'feishu':
            this.fsLogin();
            break;
          case 'dingding':
            this.ddLogin();
            break;
        }
      }
    },
    // 第三方对接信息
    async queryTpcode() {
      const res = await user.queryTpcode();
      if (res) {
        this.tpCodeList = res.data;
        if (res.data.length) {
          this.tpCodeList.unshift({ type: 'password' });
        }
      }
    },
    //微信扫码登录
    wxLogin() {
      console.log(store.state.user.tenantId);
      const qrCode = this.qrCode;
      const params = {
        self_redirect: false,
        id: 'qrcode-wage',
        appid: qrCode.app_key,
        scope: 'snsapi_login',
        redirect_uri: encodeURIComponent(`https://cloud.2175.cn/no-secret-wage/noSecretWechat`),
        state: store.state.user.tenantId,
      };
      var obj = new WxLogin(params);
    },
    //企业微信扫码登录
    wwLogin() {
      const qrCode = this.qrCode;
      let wwLogin = new WwLogin({
        id: 'qrcode-wage',
        appid: qrCode.app_key, //'ww3ce2de1b90860847',
        agentid: qrCode.agent_id, //'1000012',
        redirect_uri: encodeURIComponent(`https://cloud.2175.cn/no-secret-wage/noSecretWeix`),
        state: store.state.user.tenantId,
        lang: store.state.lang === 'en' ? 'en' : 'zh',
      });
    },
    //飞书扫码登录
    fsLogin() {
      const qrcode = document.getElementById('qrcode-wage');
      if (qrcode.firstChild) {
        qrcode.removeChild(qrcode.firstChild);
      }
      const url = encodeURIComponent(`https://cloud.2175.cn/no-secret-wage/scanCodeFeis`);
      const goto = `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=${this.qrCode.app_key}&redirect_uri=${url}&response_type=code&state=STATE`;
      let fsLogin = new QRLogin({
        id: 'qrcode-wage',
        goto: goto,
        width: '500',
        height: '300',
        style: 'width:400px;height:400px',
      });
      let handleMessage = function (event) {
        let origin = event.origin;
        // 使用 matchOrigin 方法来判断 message 来自页面的url是否合法
        if (fsLogin.matchOrigin(origin)) {
          let loginTmpCode = event.data;
          // 在授权页面地址上拼接上参数 tmp_code，并跳转
          window.location.href = `${goto}&tmp_code=${loginTmpCode}`;
        }
      };
      if (typeof window.addEventListener != 'undefined') {
        window.addEventListener('message', handleMessage, false);
      } else if (typeof window.attachEvent != 'undefined') {
        window.attachEvent('onmessage', handleMessage);
      }
      //提示文字--使用飞书扫码登录2175
      const text = document.createElement('p');
      const text2 = document.createElement('p');
      text.style.fontSize = '13px';
      text.style.position = 'relative';
      text2.style.position = 'relative';
      text.style.bottom = '60px';
      text2.style.bottom = '55px';
      text.innerText = i18n.t('title276');
      text2.innerText = '"' + i18n.t('title278') + '"';
      qrcode.appendChild(text);
      qrcode.appendChild(text2);
      const qrcodeImg = document.getElementById('qrcode-img');
      const title = document.createElement('h2');
      title.style.fontWeight = '500';
      title.style.position = 'absolute';
      title.style.left = '0';
      title.style.right = '0';
      title.style.top = '100px';
      title.style.margin = 'auto';
      title.innerText = i18n.t('title248');
      qrcode.appendChild(title);
    },
    //钉钉扫码登录
    ddLogin() {
      const url = encodeURIComponent(`https://cloud.2175.cn/no-secret-wage/noSecret`);
      const goto = encodeURIComponent(
        `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${this.qrCode.app_key}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${url}`
      );
      let ddLogin = new DDLogin({
        id: 'qrcode-wage',
        goto: goto,
        width: '400',
        height: '300',
        style: 'border:none;background-color:#FFFFFF;color:red',
      });
      let handleMessageDD = function (event) {
        console.log('->>event', event);
        let origin = event.origin;
        // console.log('origin', event.origin);
        if (origin == 'https://login.dingtalk.com') {
          //判断是否来自ddLogin扫码事件。
          let loginTmpCode = event.data;
          //获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了
          // window.location.href = `${goto}&loginTmpCode=${loginTmpCode}`;
          window.location.href = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=SuiteKey&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=REDIRECT_URI&loginTmpCode=${loginTmpCode}`;
        }
      };
      if (typeof window.addEventListener != 'undefined') {
        window.addEventListener('message', handleMessageDD, false);
      } else if (typeof window.attachEvent != 'undefined') {
        window.attachEvent('onmessage', handleMessageDD);
      }
    },
    plupLoadSubmit() {
      if (this.passwordType === 'textarea') {
        this.$refs.plupLoad.uploadFile(false);
      } else {
        this.submit();
      }
    },
    async submit() {
      this.loading = true;
      const valid = this.content ? true : await this.$refs.form.validate();
      if (valid) {
        if (this.onOk) {
          if (this.passwordType === 'textarea') {
            this.form.attachments = this.attachments;
          }
          const ok = this.content ? true : await this.onOk(this.form);
          if (ok) {
            this.visible = false;
            this.reject('submit');
            this.remove();
          }
        } else {
          this.visible = false;
          this.reject('submit');
          this.remove();
        }
      }
      this.loading = false;
    },
    // 切换密码是否显示
    switchPasswordType(type) {
      this.passwordType = type;
      this.iconType = type === 'password' ? 'iconyanjing' : 'iconyanjing1';
    },
    show() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.sitePwdInput.focus();
      });
      this.promise = new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      }).catch(() => {});
      // 返回promise对象
      return this.promise;
    },
    cancel() {
      if (this.onCancel) {
        this.onCancel();
      }
      this.visible = false;
      this.reject('cancel');
      if (sessionStorage.getItem('hrefIcon')) {
        const targetNode = document.querySelector(`#${sessionStorage.getItem('hrefIcon')}`);
        targetNode.style.visibility = 'visible';
        sessionStorage.removeItem('hrefIcon');
      }
      this.remove();
    },
    remove() {
      setTimeout(() => {
        this.destroy();
      }, 300);
    },
    destroy() {
      this.$destroy();
      document.body.removeChild(this.$el);
    },
  },
};
</script>
<style lang="less">
.verify-home {
  .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal {
      top: 0;
    }
    #qrcode-wage {
      iframe {
        border: none;
      }
    }
  }
  .verify-body {
    position: relative;
    .ivu-input-group-append,
    .ivu-input-group-prepend {
      border: none;
      background-color: transparent;
    }
    .ivu-form-item-content {
      margin-left: 0 !important;
      button {
        width: 100%;
        height: 50px;
        margin-top: 10px;
      }
    }
    .ivu-form-item {
      margin-bottom: 0 !important;
    }

    .plul-load-item {
      margin-top: 20px;

      button {
        width: auto;
        height: auto;
        margin-top: 0;
      }
    }

    .password-wrapper-item {
      .ivu-input-wrapper {
        height: 50px;
        padding: 0 30px;
        background-color: #f5f9fa;
        border-radius: 25px;
        margin-bottom: 10px;
        .ivu-icon {
          font-size: 28px;
          color: @primary-color;
        }
        .ivu-input {
          border: none;
          height: 50px !important;
          background-color: #f5f9fa;
          font-size: 16px;
          &:focus {
            box-shadow: none;
          }
        }
      }
    }
  }
  .qrcode-box {
    display: flex;
    justify-content: space-between;
    .code-login {
      height: 30px;
      display: flex;
      div {
        button {
          padding: 0;
        }
      }
    }
  }
}
</style>
